<template>
  <div>
    <el-row>
      <el-col :span="24" class="text-right"></el-col>
    </el-row>

    <div class="margin-top">
      <el-table
        :data="productDetailSeckillInfo.products"
        border
        style="width: 100%"
        size="small"
      >
        <el-table-column prop="prodName" :label="$t('productDetailSeckill.productName')" align="center" />
        <el-table-column prop="killHours" :label="$t('productDetailSeckill.killHours')" align="center" />
        <el-table-column prop="continueHours" :label="$t('productDetailSeckill.continueHours')" align="center" />
        <el-table-column prop="totalCount" :label="$t('productDetailSeckill.validPurchase')" align="center" />
        <el-table-column prop="oneCount" :label="$t('productDetailSeckill.onePurchase')" align="center" />
        <el-table-column :label="$t('productDetailSeckill.killPrice')" align="center">
          <template #default="{row}">￥{{row.killPrice}}</template>
        </el-table-column>
        <el-table-column :label="$t('productDetailSeckill.singlePrice')" align="center">
          <template #default="{row}">￥{{row.price}}</template>
        </el-table-column>
        <el-table-column prop="killStock" :label="$t('productDetailSeckill.limit')" align="center" />
        <el-table-column :label="$t('productDetailSeckill.status')" align="center">
          <template #default="{row}">{{row.state == '1001'?'开启':'关闭'}}</template>
        </el-table-column>
        <el-table-column :label="$t('productDetailSeckill.validity')" align="center">
          <template #default="{row}">{{row.startTime}}~{{row.endTime}}</template>
        </el-table-column>
      </el-table>

      <el-row class="margin-top">
        <el-col :span="12"></el-col>
        <el-col :span="12" class="text-right">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="pagination.currentPage"
            :page-size="pagination.pageSize"
            layout="total, prev, pager, next"
            :total="pagination.total"
          />
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { getShopId } from '@/api/shop/shopApi'
import { listProductSeckill } from '@/api/goods/productDetailApi'

export default {
  name: 'ProductDetailSeckill',
  data() {
    return {
      productDetailSeckillInfo: {
        products: [],
        productId: ''
      },
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  methods: {
    open(params) {
      this.productDetailSeckillInfo.productId = params.productId
      this.loadProductDetailSeckillData()
    },
    async loadProductDetailSeckillData() {
      const res = await listProductSeckill({
          productId: this.productDetailSeckillInfo.productId,
          page: this.pagination.currentPage,
          row: this.pagination.pageSize,
          shopId: getShopId()
      })

      this.productDetailSeckillInfo.products = res.data
      this.pagination.total = res.records
    },
    handleCurrentChange(currentPage) {
      this.pagination.currentPage = currentPage
      this.loadProductDetailSeckillData()
    }
  }
}
</script>

<style scoped>
.margin-top {
  margin-top: 20px;
}
.text-right {
  text-align: right;
}
</style>